import { NodeModel } from "../_model/NodeModel";
import { DecorationInput } from "./decorationInput"
import { Types } from "../../utils/nodeTypes"
import Properties from "../_model/ModelEngineeringProperties";

class Input extends NodeModel {
    constructor() {
        super("Input");

        this.type = new Types().Input
        this.title = "Input";
        this.x = 0;
        this.y = 0;
        this.xText = () => this.x + (this.width / 2)
        this.height = 42;
        this.pathLineCenter = () => `M${this.x},${this.y + (this.height/2)}L${this.x + this.width},${this.y + (this.height/2)}`
        this.heightText = (this.height / 2) - 5;
        this.heightValue = this.height - 2;
        this.width = 70;
        this.data = [new Properties({...this, height: 0 })]
        this.dataType = ''
        this.isvmCTon = false;

        this.decorate = async function(callback) {
            this.decorator = new DecorationInput();
            await this.decorator.init(this, callback)
        };

        this.update = function (nodeEdited) {
            this.dataType = nodeEdited.dataType

            this.data = nodeEdited.attrs
            if (nodeEdited.attrs) {
                this.data[0].caption = ''
                this.data[0].unit = ''
                this.data[0].height = 0
                this.data[0].isInput = true
            }

            this.isvmCTon = nodeEdited.isvmCTon;
            this.expressionVisible = nodeEdited.expressionVisible

            this.title = nodeEdited.title
            let valueLenght = this.data.length > 0 ? this.data[0].value.length : 0
            let lenghtOfFont = this.title.length > valueLenght ? this.title.length * 9 : valueLenght * 9
            this.width = lenghtOfFont;

            this.decorator.setTextAndAdjustWidth()
        }

        this.clone = function() {
            let cloned = new Input();
            cloned.id = this.id;
            cloned.idName = this.idName
            cloned.type = this.type
            cloned.title = this.title
            cloned.width = this.width
            cloned.x = this.x;
            cloned.y = this.y;
            cloned.dataType = this.dataType
            cloned.readOnly = this.readOnly
            cloned.expressionVisible = this.expressionVisible
            cloned.isvmCTon = this.isvmCTon;
            cloned.data = this.data.map(d => d.clone());
            return cloned;
        }

        this.copyFrom = (node) => {
            this.simpleCopyFrom(node)
            this.title = node.title
            this.dataType = node.dataType
            this.isvmCTon = node.isvmCTon;
            this.data = node.data.map(d => new Properties({...d }))
        }
    }
}


export { Input };